import React from "react";
import { InquiryToCustomerStatus } from "@/src/types/Entities/InquiryToCustomer";
import { useInquiryToCustomers } from "@/src/hooks/queries/inquiryToCustomer";
import { MinimalCase } from "@/src/types/Entities/MinimalCase";
import AlertLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertLegalbird";
import AlertContentLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertContentLegalbird";
import Grid from "@mui/material/Grid";

type ActiveInquiryProps = {
  minimalCase: MinimalCase;
};

export default function CaseNeedsAttention({ minimalCase }: ActiveInquiryProps) {
  const inquiryFilters = {
    productId: minimalCase.id,
    "status[0]": InquiryToCustomerStatus.STATUS_OPEN,
    "status[1]": InquiryToCustomerStatus.STATUS_OVERDUE,
  };

  const { data: inquiries } = useInquiryToCustomers(inquiryFilters);

  const inquiriesLength = inquiries?.length ?? 0;

  if (inquiriesLength > 0 || minimalCase.name === "pendingCase") {
    return (
      <Grid size={{ xs: 12, md: 12 }} sx={{ marginTop: "1rem" }}>
        <AlertLegalbird severity={"warning"}>
          <AlertContentLegalbird
            title={inquiriesLength > 1 ? "In diesem Fall sind Rückmeldungen durch Sie nötig." : "In diesem Fall ist eine Rückmeldung durch Sie nötig."}
          />
        </AlertLegalbird>
      </Grid>
    );
  }

  return null;
}
